import * as React from 'react';
import CouponGuidance from '../../../../../../models/data/CouponGuidance';
import InterestBasisSwitch from './InterestBasisSwitch';
import FixedGuidanceEditor from './FixedGuidanceEditor';
import FloatingGuidanceEditor from './FloatingGuidanceEditor';
const CouponGuidanceEditor = ({ value, onChange }) => {
    const [interestBasis, setInterestBasis] = React.useState(value?.floating !== undefined ? 'floating' : 'fixed');
    const onChangeFloating = React.useCallback((event) => {
        const updated = new CouponGuidance({ floating: event.target.value });
        onChange({ target: { value: updated } });
    }, [onChange]);
    const onChangeFixed = React.useCallback((event) => {
        const updated = new CouponGuidance({ fixed: event.target.value });
        onChange({ target: { value: updated } });
    }, [onChange]);
    const content = React.useMemo(() => {
        switch (interestBasis) {
            case 'fixed':
                return React.createElement(FixedGuidanceEditor, { value: value?.fixed, onChange: onChangeFixed });
            case 'floating':
                return React.createElement(FloatingGuidanceEditor, { value: value?.floating, onChange: onChangeFloating });
            default:
                return undefined;
        }
    }, [interestBasis, onChangeFixed, onChangeFloating, value?.fixed, value?.floating]);
    return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
        React.createElement(InterestBasisSwitch, { interestBasis: interestBasis, setInterestBasis: setInterestBasis }),
        content));
};
export default CouponGuidanceEditor;
